import React, {FC} from "react";
import {ConfigInterface} from "../../config";
import {NavLink, useLocation} from "react-router";
import {AppName, navigationTabs} from "./navigation";
import {findActiveNavigationTab} from "./findActiveNavigationTab";

type NavigationTabsProps = {config: ConfigInterface, app: AppName}

export const DesktopNavigationTabs: FC<NavigationTabsProps> = (props) => {
  const tabs = useNavigationTabs(props.config, props.app)

  return <div className={'flex tabs-center'}>
    {tabs.map(tab => <NavLink key={tab.text} to={tab.url} className={tab.isActive ? 'text-sm font-medium px-2 py-1 rounded-xs bg-white text-brand-800' : 'text-sm font-medium px-2 py-1 rounded-xs'}>{tab.text}</NavLink>)}
  </div>
}
export const MobileNavigationTabs: FC<NavigationTabsProps> = (props) => {
  const tabs = useNavigationTabs(props.config, props.app)

  return <div className={'grid grid-cols-2 gap-2 mx-2'}>
    {tabs.map(tab => <NavLink key={tab.text} to={tab.url} className={tab.isActive ? 'text-sm font-medium px-2 py-1 rounded-t bg-white text-brand-950' : 'text-sm font-medium px-2 py-1 rounded-t'}>{tab.text}</NavLink>)}
  </div>
}

const useNavigationTabs = (config: ConfigInterface, app: AppName) => {
  const {pathname} = useLocation()
  const baseUrls: Record<AppName, string> = {planning: config.planningUrl, crm: config.crmUrl}

  const activeTab = findActiveNavigationTab(navigationTabs, app, pathname)

  return navigationTabs.map(tab => ({
    ...tab,
    url: baseUrls[tab.app] + tab.link,
    isActive: tab === activeTab,
  }))
}
